// =============================================================================
// state
// =============================================================================
const state = {
  loginToken: localStorage.lcpe_token,
  loginKeeperToken: localStorage.lcpe_keeper_token,
  loginUserToken: localStorage.lcpe_user_token,
  loginType: null,
  menu_status: 0,
  lang: (localStorage.lcpe_lang_flg) ? localStorage.lcpe_lang_flg : 'en',
  unaccepted_num: 0,
  unregistered_num: 0,
  owner_info_defect_flag: localStorage.lcpe_owner_info_defect_flag,
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  login_token: state => {
    if (state.loginType === 'manage') {
      return state.loginToken;
    } else if (state.loginType === 'keeper') {
      return state.loginKeeperToken;
    } else {
      return state.loginUserToken;
    }
  },
  menu_status: state => state.menu_status,
  lang: state => state.lang,
  unaccepted_num: state => state.unaccepted_num,
  unregistered_num: state => state.unregistered_num,
  owner_info_defect_flag: state => eval(state.owner_info_defect_flag),
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_login_type (state, value) {
    state.loginType = value;
  },
  set_data (state, value) {
    if (state.loginType === 'manage') {
      state.loginToken = value.token;
      localStorage.lcpe_token = value.token;
    } else if (state.loginType === 'keeper') {
      state.loginKeeperToken = value.token;
      localStorage.lcpe_keeper_token = value.token;
    } else {
      state.loginUserToken = value.token;
      localStorage.lcpe_user_token = value.token;
    }
  },
  set_status (state, value) {
    state.menu_status = value;
  },
  set_lang (state, value) {
    if (value === 'ja' || value === 'en') {
      state.lang = value;
      localStorage.lcpe_lang_flg = value;
    }
  },
  set_unaccepted_num (state, value) {
    state.unaccepted_num = value;
  },
  set_unregistered_num (state, value) {
    state.unregistered_num = value;
  },
  set_owner_info_defect_flag (state, value) {
    state.owner_info_defect_flag = value;

    localStorage.lcpe_owner_info_defect_flag = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
